var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSirycar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 566.62 212.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sirycar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.44,636.66,265.37,623c7.44,4.82,18.53,8.19,29.11,8.19,12.1,0,17-3.59,17-8.42,0-14.68-51.28-4.59-51.28-33.75,0-13.34,12.09-24.44,37.17-24.44,11.09,0,22.43,2.35,30.62,7l-6.3,13.79a54.57,54.57,0,0,0-24.45-6.17c-12.09,0-16.76,4-16.76,9,0,14.47,51.29,4.49,51.29,33.31,0,13.12-12.22,24.33-37.43,24.33C280.37,645.74,266.25,642,258.44,636.66Z",
    transform: "translate(-258.44 -433.28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.76,565.9h20.41v78.5H345.76Z",
    transform: "translate(-258.44 -433.28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.28,644.4l-17-21.87H407.5V644.4H387.08V565.9h38.18c23.57,0,38.31,10.88,38.31,28.48,0,11.78-6.68,20.41-18.14,24.79l19.78,25.23Zm-19.15-63.7H407.5v27.37h16.63c12.48,0,18.78-5.16,18.78-13.69S436.61,580.7,424.13,580.7Z",
    transform: "translate(-258.44 -433.28)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M520.77,616.59V644.4H500.36v-28L466.21,565.9h21.67l23.57,34.88L535,565.9h20Z",
    transform: "translate(-258.44 -433.28)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M558.28,605.15c0-23.66,20.42-40.59,47.89-40.59,15.24,0,28,4.93,36.29,13.9l-13.11,10.77a29.88,29.88,0,0,0-22.17-9.2C590.67,580,579,590.35,579,605.15s11.72,25.12,28.23,25.12A29.57,29.57,0,0,0,629.35,621l13.11,10.77c-8.32,9.08-21.05,14-36.42,14C578.7,645.74,558.28,628.81,558.28,605.15Z",
    transform: "translate(-258.44 -433.28)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M711.51,627.58h-41l-7.81,16.82H641.83l39.31-78.5H701.3l39.44,78.5H719.32Zm-6.43-13.8-14-30-14,30Z",
    transform: "translate(-258.44 -433.28)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M803.14,644.4l-17-21.87H767.35V644.4H746.94V565.9h38.18c23.56,0,38.3,10.88,38.3,28.48,0,11.78-6.67,20.41-18.14,24.79l19.78,25.23ZM784,580.7H767.35v27.37H784c12.48,0,18.78-5.16,18.78-13.69S796.46,580.7,784,580.7Z",
    transform: "translate(-258.44 -433.28)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M800.61,494.69s-11.18-29.2-26.71-41.63c0,0-29.2,10.57-126.74-11.8s-162.76,7.46-188.23,26.09c0,0,64.61-37.27,136.05-26.71s125.49,28,175.81,21.12C770.79,461.76,792.53,477.29,800.61,494.69Z",
    transform: "translate(-258.44 -433.28)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M609.27,477.29l34.17-13s-57.16-32.93-157.18-5c0,0,74.76-37.9,171.67,3.52C657.93,462.8,652.55,468.18,609.27,477.29Z",
    transform: "translate(-258.44 -433.28)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M524.57,513.32s47.22,14.09,125.08-27.74,130.46-5.8,130.46-5.8,24.85,17.7,27.95,59.33c0,0-7.24-74.24-87.18-66.79S604.09,536.93,524.57,513.32Z",
    transform: "translate(-258.44 -433.28)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M610.3,486.82s-63.16,23.4-166.9-6.42-159.66,12.42-171.46,20.5c0,0,3.1,26.71,15.53,43.49,0,0-9.32-25.68-6-41.42,0,0,53.84-34,109.34-25.26s85.73,15.73,96.5,17.39S549.42,507.94,610.3,486.82Z",
    transform: "translate(-258.44 -433.28)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M611.3,485.82s-63.16,23.4-166.9-6.42-159.66,12.42-171.46,20.5c0,0,3.1,26.71,15.53,43.49,0,0-9.32-25.68-6-41.42,0,0,53.84-34,109.34-25.26s85.73,15.73,96.5,17.39S550.42,506.94,611.3,485.82Z",
    transform: "translate(-258.44 -433.28)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M531,551.43s-26.09,6.62-97.74-41c0,0-27.75-20.3-53.43-26.1s-79.52,7-64.19,62.13c0,0-6.22-61.71,56.74-57.16,0,0,25.26,3.32,66.67,31.07S499.11,548.53,531,551.43Z",
    transform: "translate(-258.44 -433.28)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M431.19,526.16S454,544,458.93,544.39c0,0-17.39-3.73-24.85-9.94,0,0,0,8.69-12.83,17.39C421.25,551.84,431.6,540.24,431.19,526.16Z",
    transform: "translate(-258.44 -433.28)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M563.92,551.43s26.09,6.62,97.74-41c0,0,27.75-20.3,53.42-26.1s79.52,7,64.2,62.13c0,0,6.21-61.71-56.74-57.16,0,0-25.26,3.32-66.68,31.07S595.81,548.53,563.92,551.43Z",
    transform: "translate(-258.44 -433.28)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M668.7,526.16S645.92,544,641,544.39c0,0,17.4-3.73,24.85-9.94,0,0,0,8.69,12.84,17.39C678.64,551.84,668.29,540.24,668.7,526.16Z",
    transform: "translate(-258.44 -433.28)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSirycar);
export default __webpack_public_path__ + "static/media/sirycar.53d30273caa7ebde845f77e883ca9fa7.svg";
export { ForwardRef as ReactComponent };